import * as React from 'react';

import {SegmentedControl} from 'shells/card/segmented-control';
import {FormField} from 'shells/form/form-field';
import {Stack} from 'shells/layout/stack/stack';
import {LoadingText} from 'shells/loading-placeholder/loading-text';
import type {SavedSettingToastState} from 'shells/saved-setting-toast/saved-setting-toast';
import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {DigestFrequencyEnum} from 'nutshell-graphql-types';
import type {
    DigestSubscriptionUpdateInput,
    GetDigestConfiguration_digestConfiguration_subscription as DigestSubscription,
} from 'nutshell-graphql-types';

import {FREQUENCY_OPTIONS} from './consts';

type Props = {
    updateDigestSubscription: (
        arg1: DigestSubscriptionUpdateInput,
        arg2?: DigestSubscription | null | undefined
    ) => Promise<any>;
    isSubscribedToMorningJolt: boolean;
    morningJoltFrequency: DigestFrequencyEnum;
    isLoadingMorningJolt: boolean;
    subscription: DigestSubscription | null | undefined;
    nextSendDate: string | null | undefined;
};

export function MorningJoltConfig(props: Props) {
    const [saveToastState, setSaveToastState] = React.useState<SavedSettingToastState>('initial');

    function handleSave(
        args: DigestSubscriptionUpdateInput,
        subscription?: DigestSubscription | null
    ) {
        setSaveToastState('saving');
        props.updateDigestSubscription(args, subscription);
        setTimeout(() => {
            setSaveToastState('complete');
        }, 500);
        setTimeout(() => {
            setSaveToastState('initial');
        }, 1000);
    }

    return (
        <FormField
            innerId='morning-jolt-config'
            label={
                <Body size='large' isBold={true} color='dark'>
                    User digest
                </Body>
            }
            sublabel={
                <Body size='large' isBold={false} color='light'>
                    Highlights of your sales activity, including recent performance, upcoming tasks,
                    and key priorities to focus on next
                </Body>
            }
            saveToastState={saveToastState}
            noMargin={true}
        >
            <Stack spacing={16}>
                <Stack isHorizontal={true} spacing={8} alignItems='center'>
                    <Switch
                        onChange={() => {
                            handleSave(
                                {
                                    digestType: 'MORNING_DIGEST',
                                    isActive: !props.isSubscribedToMorningJolt,
                                },
                                props.subscription
                            );
                        }}
                        isRounded={true}
                        isOn={props.isSubscribedToMorningJolt}
                        isSmall={true}
                        isDisabled={props.isLoadingMorningJolt}
                    />
                    <Body size='large' isBold={false} color='dark'>
                        Subscribe
                    </Body>
                </Stack>
                {props.isSubscribedToMorningJolt && (
                    <Stack spacing={8}>
                        <SegmentedControl
                            buttonOptions={FREQUENCY_OPTIONS}
                            selectedValue={props.morningJoltFrequency}
                            setSelectedValue={(frequency) => {
                                handleSave(
                                    {
                                        digestType: 'MORNING_DIGEST',
                                        frequency: frequency,
                                    },
                                    props.subscription
                                );
                            }}
                            isAnimated={true}
                            isDisabled={props.isLoadingMorningJolt}
                        />
                        {!props.nextSendDate ? (
                            <LoadingText height={16} width={400} />
                        ) : (
                            <Body size='normal' isBold={false} color='light'>
                                Next email will be sent out {props.nextSendDate}
                            </Body>
                        )}
                    </Stack>
                )}
            </Stack>
        </FormField>
    );
}
